import type { TablePaginationConfig } from 'antd'
import { useState } from 'react'

import type { PageArgs } from '../hooks/useGpuAdmin'

const PAGE_SIZE = 50

// The GPU admin API pages by limit/offset without a total: a full page
// implies there may be one more.
export function useOffsetPagination() {
  const [page, setPage] = useState(1)
  const args: PageArgs = { limit: PAGE_SIZE, offset: (page - 1) * PAGE_SIZE }

  const pagination = (received: number): TablePaginationConfig => ({
    current: page,
    pageSize: PAGE_SIZE,
    total: args.offset + received + (received === PAGE_SIZE ? 1 : 0),
    showSizeChanger: false,
    onChange: setPage,
  })

  return { args, pagination }
}
